import React, { useState } from 'react';
import { Mail, X, RefreshCw } from 'lucide-react';
import { supabase } from '../lib/supabaseClient';

interface EmailConfirmationBannerProps {
  email?: string;
}

const EmailConfirmationBanner: React.FC<EmailConfirmationBannerProps> = ({ email }) => {
  const [dismissed, setDismissed] = useState(false);
  const [resending, setResending] = useState(false);
  const [resent, setResent] = useState(false);

  if (dismissed) return null;

  const handleResend = async () => {
    if (!email || resending) return;

    setResending(true);
    try {
      const { error } = await supabase.auth.resend({
        type: 'signup',
        email,
      });

      if (error) {
        console.error('Erreur renvoi email:', error);
      } else {
        setResent(true);
        setTimeout(() => setResent(false), 5000);
      }
    } catch (err) {
      console.error('Exception renvoi email:', err);
    } finally {
      setResending(false);
    }
  };

  return (
    <div className="bg-amber-50 border-b border-amber-200 px-4 py-3">
      <div className="max-w-lg mx-auto flex items-center gap-3">
        <div className="flex-shrink-0">
          <Mail className="w-5 h-5 text-amber-600" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm text-amber-800">
            <span className="font-medium">Confirmez votre email</span>
            {' '}- Un lien de confirmation a été envoyé à{' '}
            <span className="font-medium">{email}</span>
          </p>
        </div>
        <div className="flex items-center gap-2 flex-shrink-0">
          {resent ? (
            <span className="text-xs text-green-600 font-medium">Envoyé !</span>
          ) : (
            <button
              onClick={handleResend}
              disabled={resending}
              className="text-amber-700 hover:text-amber-900 p-1 rounded transition-colors disabled:opacity-50"
              title="Renvoyer l'email"
            >
              <RefreshCw className={`w-4 h-4 ${resending ? 'animate-spin' : ''}`} />
            </button>
          )}
          <button
            onClick={() => setDismissed(true)}
            className="text-amber-500 hover:text-amber-700 p-1 rounded transition-colors"
            title="Masquer"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default EmailConfirmationBanner;
